import { render, staticRenderFns } from "./TeacherAccount.vue?vue&type=template&id=5b88d4ae&scoped=true"
import script from "./TeacherAccount.vue?vue&type=script&lang=js"
export * from "./TeacherAccount.vue?vue&type=script&lang=js"
import style0 from "./TeacherAccount.vue?vue&type=style&index=0&id=5b88d4ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88d4ae",
  null
  
)

export default component.exports